<!-- 
  Header Component Template
  Feature: 013-shell-navigation Phase 9
  
  Simplified header with logo only.
  Profile and Logout are now accessed via /profile route (sidebar/bottom-nav).
-->
<nav class="navbar navbar-expand-lg fixed-top">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">
      <img src="/assets/rettxlogo-white.png" class="logo me-2" alt="rettX Logo">
    </a>
    @if (showPatientPill()) {
      <app-header-patient-pill class="ms-auto"></app-header-patient-pill>
    }
  </div>
</nav>